import React, { useState } from 'react'
import {
  Tabs,
  TabsBody,
  TabPanel,
} from '@material-tailwind/react/components/Tabs'
import { PageProps } from 'gatsby'
import { TabsHeaderCommon } from '../../common/tabs/TabsHeaderCommon'
import { getDefaultActiveTab } from '../../../Utils/functionnals'
import { ToolType } from '../mapper'
import { TeaserProps } from '../../offers/teaser'
import { FirmTeaserProps } from '../../firms'
import FirmOfferTemplate from '../../firms/firm/firmOfferTemplate'
import { Button, Link } from '../../ui'
import { FirmList } from '../../search/firm/FirmList'

export const ToolTabs = ({
  location,
  tool,
  offers,
  firms,
}: {
  location: PageProps['location']
  tool: ToolType | null
  offers: TeaserProps[]
  firms: FirmTeaserProps[]
}) => {
  const [activeTab, setActiveTab] = useState<string>(
    getDefaultActiveTab(location) || 'cabinets',
  )

  if (!tool || (offers.length === 0 && firms.length === 0)) {
    return null
  }

  const tabsTitle = [
    {
      label: 'Cabinets',
      key: 'cabinets',
      pill: firms.length,
    },
  ]

  if (offers.length > 0) {
    tabsTitle.push({
      label: 'Offres',
      key: 'offres',
      pill: offers.length,
    })
  }
  return (
    <Tabs
      className="xl:w-[1115px] lg:w-[950px] 2xl:w-[1320px] mx-auto mb-14 lg:mb-20"
      value={activeTab}
    >
      <TabsHeaderCommon tabsTitle={tabsTitle} setActiveTab={setActiveTab} />
      <TabsBody className="px-4 mt-4 md:mt-6 md:pr-0 md:pl-4">
        <TabPanel value="cabinets" className="p-0 py-2 space-y-4">
          <h2 className="mb-5 text-3xl font-semibold text-center mt-15 text-night">{`Les cabinets qui utilisent ${tool?.name}`}</h2>
          <FirmList firms={firms} />
          <div className="flex flex-col items-center space-y-4 md:space-y-6 md:py-10">
            <Link
              to={`/cabinets?filters[tools][0]=${tool.name}`}
              className="flex items-center"
            >
              <Button
                color="primary"
                label="Filtrer les cabinets"
                invert
              />
            </Link>
            <p className="text-center text-night">
              Ou venez déposer directement votre cv 😁
            </p>
            <a
              href="https://lamadash.fr/signup_login_candidat"
              className="flex items-center"
            >
              <Button color="primary" label="Déposer votre CV" />
            </a>

          </div>
        </TabPanel>

        <TabPanel value="offres" className="px-0">
          <h2 className="mb-5 text-3xl font-semibold text-center mt-15 text-night">{`Les offres d'emploi qui parlent de ${tool?.name}`}</h2>
          <FirmOfferTemplate offers={offers} />
        </TabPanel>
      </TabsBody>
    </Tabs>
  )
}
